'use strict';

import React, { PropTypes } from 'react';
import Analytics from '../utils/Analytics';
import AnalyticsEvents from '../constants/AnalyticsEvents';
import ZineActionCreators from '../actions/ZineActionCreators';
import StampActionCreators from '../actions/StampActionCreators';
import NavigationContextTypes from '../constants/NavigationContextTypes';
import PageControlsTypes from '../constants/PageControlsTypes';
import ZineStore from '../stores/ZineStore';
import ZineDraftStore from '../stores/ZineDraftStore';
import StampStore from '../stores/StampStore';
import ZineLatestStampStore from '../stores/ZineLatestStampStore';
import createStoreMixin from '../mixins/createStoreMixin';
import Container from '../organisms/Container';
import Group from '../organisms/Group';
import EmptyState from '../molecules/EmptyState';
import ZineCover from '../molecules/ZineCover';
import Loader from '../atoms/Loader';
import ScrollStateMixin from '../mixins/ScrollStateMixin';
import BackColorMixin from '../mixins/BackColorMixin';
import Page from '../organisms/Page';
import DocumentTitle from '../atoms/DocumentTitle';
import PureRenderMixin from '../mixins/PureRenderMixin';
import PageQueryMixin from '../mixins/PageQueryMixin';
import Button from '../atoms/Button';
import SidebarActionCreators from '../actions/SidebarActionCreators';
import SidebarTypes from '../constants/SidebarTypes';
import ZineStatus from '../constants/ZineStatus';
import AppContext from '../AppContext';
import { isInitialPath } from '../router';

const ZinePage = React.createClass({
  mixins: [
    createStoreMixin(
      ZineStore,
      ZineDraftStore,
      ZineLatestStampStore,
      StampStore
    ),
    ScrollStateMixin,
    BackColorMixin,
    PageQueryMixin,
    PureRenderMixin
  ],

  propTypes: {
    params: PropTypes.shape({
      zineSlug: PropTypes.string.isRequired
    }).isRequired
  },

  statics: {
    getHandlerKey(params) {
      return params.zineSlug;
    },

    willTransitionTo() {
      ZineActionCreators.destroyZineDraft();
    },

    willTransitionFrom(transition) {
      if (ZineDraftStore.isEditing()) {
        ZineActionCreators.destroyZineDraft();
      }
    }
  },

  parseSlug(props) {
    props = props || this.props;
    return props.params.zineSlug;
  },

  getScrollState(scrollY) {
    return {
      isScrolled: scrollY > 52
    };
  },

  getStateFromStores(props) {
    var slug = this.parseSlug(props),
        zine = ZineDraftStore.getActiveDraft() || ZineStore.get(slug);

    return {
      zine: zine,
      isEditing: ZineDraftStore.isEditing(),
      latestStamps: ZineLatestStampStore.getStamps(slug)
    };
  },

  getNavigationContext() {
    const zineSlug = this.parseSlug(this.props);
    const { isScrolled, isEditing } = this.state;

    return [NavigationContextTypes.ZINE, {
      zineSlug,
      isScrolled,
      isEditing
    }];
  },

  getPageControls() {
    const zineSlug = this.parseSlug(this.props);
    const { isEditing } = this.state;
    const type = isEditing ? PageControlsTypes.ZINE_EDIT : PageControlsTypes.ZINE;

    return [type, { zineSlug }];
  },

  getAppContext() {
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();
    const [pageControlsType, pageControlsOptions] = this.getPageControls();

    return {
      navigationContextType,
      navigationContextOptions,
      pageControlsType,
      pageControlsOptions
    };
  },

  componentDidMount() {
    var zineSlug = this.parseSlug(this.props);

    ZineActionCreators.requestZine(zineSlug, ['contributorCount']);
    StampActionCreators.requestZineLatestPage(zineSlug, true, !isInitialPath());

    Analytics.trackEvent(AnalyticsEvents.ZINE_VIEW, {
      zineSlug: zineSlug
    });
  },

  render() {
    var { zine } = this.state;

    return (
      <AppContext {...this.getAppContext()}>
        <DocumentTitle title={zine && zine.title}>
          <Page background={zine && zine.backColor}>
            {!zine && <Loader absoluteCenter/>}
            {zine && this.renderCover()}
            {zine && this.renderLatest()}
          </Page>
        </DocumentTitle>
      </AppContext>
    );
  },

  renderCover() {
    return (
      <ZineCover zine={this.state.zine}
                 isEditing={this.state.isEditing}
                 fullWidth />
    );
  },

  renderLatest() {
    if (this.state.isEditing) {
      return;
    }

    const slug = this.parseSlug();
    const zine = this.state.zine;
    const textColor = this.getTextColor(zine.backColor);

    let itemProps;
    if (zine.status === ZineStatus.PUBLIC) {
      itemProps = {
        routeName: 'zineLatestStamp',
        routeParams: { zineSlug: slug }
      };
    } else {
      itemProps = {
        routeName: 'feedStamp'
      };
    }

    return (
      <Container context='ZinePage'
                 color={textColor}>
        <Group color={textColor}
               type='stamps'
               mode='grid'
               columns={3}
               context='Page'
               isExpectingPage={ZineLatestStampStore.isExpectingPage(slug)}
               isLastPage={ZineLatestStampStore.isLastPage(slug)}
               isInvalidated={ZineLatestStampStore.isInvalidated(slug)}
               defaultPage={this.parsePage()}
               onPageChange={this.replacePage}
               loadNextPage={this.requestNextLatestPage}
               items={this.state.latestStamps}
               itemProps={itemProps}>
          <EmptyState label='This collection does not have any stamps yet.'>
            <Button color={textColor} onClick={this.handleSubmitStampClick}>
              {zine.canEdit ? 'Add a Stamp' : 'Submit a Stamp'}
            </Button>
          </EmptyState>
        </Group>
      </Container>
    );
  },

  handleSubmitStampClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.ADD_STAMPS_TO_ZINE, {
      zineSlug: this.parseSlug()
    });
  },

  requestNextLatestPage() {
    var slug = this.parseSlug();
    StampActionCreators.requestZineLatestPage(slug);
  }
});

export default ZinePage;



/** WEBPACK FOOTER **
 ** ./pages/ZinePage.jsx
 **/